<template>
  <v-container v-if="customer" fluid class="pa-0" style="height: inherit">
    <v-row no-gutters style="height: inherit">
      <v-col :cols="isPcBool ? 7 : 12" class="px-4" :style="isPcBool ? 'background-color: #fefefe;' : ''">

        <v-row no-gutters>
          <v-col :cols="12">
            <SectionHeader :title="$t('servicesystem.common_objects.commonterms.details')" />
            <v-card v-if="editObject" v-click-outside="unfocusEntireCard">
              <slotted-card :editable="true"
                :title="editObject && editObject.Name ? editObject.Name : $t('servicesystem.common_objects.fallbackterms.no_customer_name')"
                :icon="'$customer'" :fontsize="'h3'" :externalEditTrigger="edittrigger" @editMode="setEditMode"
                @valid="setValid">
                <template v-slot:headertitle>
                  <QTextField v-model="editObject.Name"
                    :label="$t('servicesystem.common_objects.customer.customer_name')" :externaledit="editMode"
                    maxlength="50" singleline @FocusState="editMode ? null : edittrigger++" class="h3">
                  </QTextField>
                </template>
                <template v-slot:content>
                  <v-container fluid class="pa-0">
                    <v-row no-gutters>
                      <v-col cols="6" class="px-3 pt-3">
                        <v-row no-gutters>
                          <v-col>
                            <QTextField v-model="editObject.Id" maxlength="50"
                              :label="$t('servicesystem.common_objects.customer.customer_number')" disabled>
                            </QTextField>
                          </v-col>
                          <v-col>
                            <QTextField v-model="editObject.OrganisationNumber" maxlength="50"
                              :label="$t('servicesystem.common_objects.customer.organization_number')"
                              :externaledit="editMode" @FocusState="editMode ? null : edittrigger++">
                            </QTextField>
                          </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                          <v-col>
                            <EditLi :label="$t('servicesystem.common_objects.customer.credit_limit')" class="ml-n5"
                              :value="editObject.CreditLimit ? editObject.CreditLimit : $t('servicesystem.common_objects.commonterms.none')"
                              :suffix="editObject.CreditLimitExceeded ? (' (' + editObject.CreditLimitExceeded + ')') : null"
                              :valuecolor="editObject.CreditLimit ? (editObject.CreditLimitExceeded ? 'error' : 'primary') : 'disabled'" />
                          </v-col>
                          <v-col>
                            <QSwitchInput v-model="editObject.FreeFromVat"
                              :label="$t('servicesystem.common_objects.customer.free_from_vat')"
                              :externaledit="editMode" @FocusState="editMode ? null : edittrigger++">
                            </QSwitchInput>
                          </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                          <v-col>
                            <QTextField v-model="editObject.Longitude" class="mr-3" maxlength="100"
                              :label="$t('servicesystem.common_objects.customer.longitude')" :externaledit="editMode"
                              @FocusState="editMode ? null : edittrigger++">
                            </QTextField>
                          </v-col>
                          <v-col>
                            <QTextField v-model="editObject.Latitude" maxlength="100"
                              :label="$t('servicesystem.common_objects.customer.latitude')" :externaledit="editMode"
                              @FocusState="editMode ? null : edittrigger++">
                            </QTextField>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-divider vertical />
                      <v-col cols="6" class="pl-3 pr-1 pt-2">
                        <DepartmentSelect v-model="editObject.DepartmentId" :key="customer.DepartmentId" clearable
                          :externaledit="editMode" @FocusState="editMode ? null : edittrigger++">
                          <template v-if="editObject.DepartmentId" v-slot:append-outer>
                            <OpenInNewTabBtn
                              :route="{ name: 'ViewDepartment', params: { departmentId: editObject.DepartmentId } }">
                            </OpenInNewTabBtn>
                          </template>
                        </DepartmentSelect>
                        <CustomerGroupSelect v-model="editObject.CustomerGroupNo" :key="customer.CustomerGroupNo"
                          :externaledit="editMode" clearable class="mt-2" @FocusState="editMode ? null : edittrigger++">
                          <template v-if="editObject.CustomerGroupNo" v-slot:append-outer>
                            <OpenInNewTabBtn
                              :route="{ name: 'ViewCustomerGroup', params: { customerGroupId: editObject.CustomerGroupNo } }">
                            </OpenInNewTabBtn>
                          </template>
                        </CustomerGroupSelect>
                        <CustomerSelect v-model="editObject.ParentId" :key="customer.ParentId"
                          :label="$t('servicesystem.common_objects.customer.parent_org')" :externaledit="editMode"
                          :filter="{ ExcludeItemIdList: [editObject.Id] }" class="mt-2" clearable
                          @FocusState="editMode ? null : edittrigger++">
                          <template v-if="editObject.ParentId" v-slot:append-outer>
                            <OpenInNewTabBtn
                              :route="{ name: 'ViewCustomer', params: { customerId: editObject.ParentId } }">
                            </OpenInNewTabBtn>
                          </template>
                        </CustomerSelect>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row no-gutters class="px-3 pt-1" :class="editMode ? 'pb-2' : 'rounded-b'"
                      style="background-color: rgb(255 249 242);">
                      <v-col>
                        <QTextArea v-model="editObject.Comments" :backgroundcolor="'rgb(255 249 242)'"
                          :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampCustomerNote"
                          :singleline="!editObject.Comments"
                          :placeholder="!editObject.Comments ? customerNoteLabel : undefined" :label="customerNoteLabel"
                          :externaledit="editMode" @FocusState="editMode ? null : edittrigger++">
                        </QTextArea>
                      </v-col>
                    </v-row>

                  </v-container>
                  <edit-bar v-if="editMode" :externalTrigger="editMode" :saveable="valid && IsChanged"
                    @saveEmit="handleSave" @modeEmit="edittrigger++">
                  </edit-bar>
                </template>
              </slotted-card>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="hasQuotationLicense" no-gutters class="my-4">
          <v-col :cols="12">
            <CustomerConditionsCard :customerId="customer.Id">
            </CustomerConditionsCard>
          </v-col>
        </v-row>
      </v-col>

      <v-col v-if="customer && customer.Id !== undefined" :cols="isPcBool ? 5 : 12" class="px-4 pb-4"
        style="background-color: rgb(248, 248, 248) !important;">
        <v-row no-gutters>
          <v-col :cols="isPcBool ? 12 : null" :class="!isPcBool && !isPhoneBool ? 'mr-2' : ''">
            <SectionHeader :title="$t('servicesystem.common_objects.address.addresses')" />
            <v-card>
              <CustomerAddresses :Customer="customer" />
            </v-card>
          </v-col>
          <v-col :cols="isPcBool ? 12 : null" :class="!isPcBool && !isPhoneBool ? 'ml-2' : ''">
            <SectionHeader :title="$t('servicesystem.common_objects.contact.contacts')" />
            <v-card>
              <CustomerContacts :Customer="customer" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import LicenseKeys from "@/helpers/Constants/LicenseKeys";
import clientAPI from "@/api/ClientAPIMixin.js";
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import EditLi from "@/components/Inputs/EditableListItem.vue";
import DepartmentSelect from "@/components/Inputs/EntityDropdowns/DepartmentSelect2.vue";
import EditBar from "@/components/Sections/Editbar.vue";
import CustomerAddresses from "@/views/customer/customers/CustomerAddresses.vue";
import CustomerContacts from "@/views/customer/customers/CustomerContacts.vue";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import CustomerGroupSelect from "@/components/Inputs/EntityDropdowns/CustomerGroupSelect2.vue";
import OpenInNewTabBtn from "@/components/Buttons/OpenInNewTabBtn.vue";
import CustomerConditionsCard from "./CustomerConditionsCard.vue";

export default {
  name: "CustomerDetails",
  props: {
    containerItem: Object,
  },
  components: {
    SlottedCard,
    EditBar,
    SectionHeader,
    CustomerAddresses,
    CustomerContacts,
    EditLi,
    DepartmentSelect,
    CustomerSelect,
    CustomerGroupSelect,
    OpenInNewTabBtn,
    CustomerConditionsCard,
  },
  mixins: [clientAPI],

  data() {
    return {
      editObject: null,
      copyObject: null,
      edittrigger: 0,
      editMode: false,
      valid: false,
    };
  },

  mounted() {
    this.SetDetails();
  },

  methods: {
    setEditMode(bool) {
      this.editMode = bool;
    },

    setValid(bool) {
      this.valid = bool;
    },

    SetDetails() {
      var defaultobj = {
        Id: null,
        ParentId: null,
        CustomerGroupNo: "",
        Name: "",
        OrganisationNumber: "",
        CreditLimit: null,
        CreditLimitExceeded: null,
        FreeFromVat: false,
        Latitude: "",
        Longitude: "",
        IsActive: true,
        AllowPublicView: null,
        DefaultCustomerPerson: {},
        DefaultDeliveryAddress: {},
      };

      var existingcopy = Object.assign({}, this.customer);
      var obj = this.customer ? existingcopy : defaultobj;

      this.editObject = Object.assign({}, obj);
      this.copyObject = Object.assign({}, obj);
    },

    handleSave() {
      const dto = Object.assign({}, this.editObject);
      //console.log("Sending change", dto);
      this.changeCustomerById(dto)
        .then((response) => {
          //console.log("Recieved", Object.assign({}, response));
          this.$emit('SetContainerItem', response);
          this.edittrigger++;
        })
        .catch((exception) => {
          console.error(exception);
          this.customer = null;
        });
    },

    unfocusEntireCard() {
      if (!this.IsChanged && this.editMode) {
        this.edittrigger++;
      }
    },
  },

  computed: {
    customer() {
      return this.containerItem;
    },

    customerNoteLabel() {
      var override = this.FieldMapping.Customer?.Comments?.DisplayName;
      return override || this.$t("servicesystem.common_objects.customer.note");
    },

    IsChanged() {
      if (this.editObject && this.copyObject) {
        return !this.SameValue(this.editObject, this.copyObject);
      } else {
        return false;
      }
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    },

    hasQuotationLicense() {
      return this.checkIfLicencedByKey(LicenseKeys.Quotation);
    },
  },

  watch: {
    customer: function () {
      this.SetDetails();
    },

    editMode: function (newVal) {
      if (!newVal) {
        this.SetDetails();
      }
    },
  },
};
</script>


<style lang='scss'>
.q-input.h3 textarea {
  color: #5f5f5f !important;
}
</style>